import { Link } from 'react-router';
import '../Footer/Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-links-sections">
                <div className="footer-brand">
                    <div className="footer-logo">PreNumbers</div>
                    <div className="footer-tagline">
                        Refine your business financials.<br />
                        Achieve your goals with clarity and confidence.
                    </div>
                </div>
                <div className="footer-links-group">
                    <div className="footer-links-title">Product</div>
                    <Link to="/features">Features</Link>
                    <Link to="/pricing">Pricing</Link>
                    <Link to="/how-it-works">How It Works</Link>
                    <Link to="/signup">Start Free Trial</Link>
                </div>
                <div className="footer-links-group">
                    <div className="footer-links-title">Company</div>
                    <Link to="/about">About Us</Link>
                    <Link to="/our-story">Our Full Story</Link>
                    <Link to="/contact-sales">Contact Us</Link>
                    <Link to="/testimonials">Testimonials</Link>
                </div>
                <div className="footer-links-group">
                    <div className="footer-links-title">Legal</div>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/terms-of-service">Terms of Service</Link>
                    <Link to="/security">Security Information</Link>
                    <Link to="/faq">FAQ</Link>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="footer-copy">
                    © 2025 PreNumbers. All rights reserved.
                </div>
                <div className="footer-built">
                    Built with <span role="img" aria-label="heart">❤️</span> to help businesses thrive.
                </div>
            </div>
        </footer>
    );
}

export default Footer;